export default __webpack_public_path__ + "static/media/data-details.d9bae587.PNG";